<template>
   <v-dialog v-model="show" width="55vw"  class="chart-message">
      <v-card>
        <v-card-title>

          <v-btn icon>
            <v-icon small>fa-solid fa-bars</v-icon>
          </v-btn>

          <v-spacer></v-spacer>
          <!-- <v-btn icon small @click="maximize"> <v-icon small>mdi-arrow-collapse </v-icon></v-btn> -->
          <v-btn icon small @click="edit"> <v-icon small>{{ this.editMode ? 'mdi-eye' : 'mdi-pencil' }}</v-icon></v-btn>

          <v-btn icon small @click="close"> <v-icon small>fa-solid fa-xmark</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text  >
          <v-row class="pa-2">
            <v-col v-if="editMode" cols="4">
              <span class="text-h6">Settings</span>
              <v-divider class="my-2 mb-5"></v-divider>
              <v-expansion-panels variant="accordion" class="expansion-dark" multiple v-model="expandedPanels">
                <v-expansion-panel hide-actions ripple class="square-panel">
                  <v-expansion-panel-header class="px-4 justify-start expansion-panel-title" small>
                    Visualization
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-text-field v-model="message.title" label="Title">
                    </v-text-field>

                    <v-text-field v-model="message.subTitle" label="Subtitle" bg-color="grey-darken-4">
                    </v-text-field>
                    <v-select :items="chartTypes" v-model="message.messageType" label="Type" item-text="name"
                      item-value="value">
                      <template v-slot:item="{ item }">
                        <div class="ml-2">
                          <v-icon small> {{ item.icon }} </v-icon> <span class="ml-2">{{
                            item.name }}</span>
                        </div>
                      </template>
                      <template v-slot:selection="{ item }">
                        <div class="ml-2">
                          <v-icon small> {{ item.icon }} </v-icon> <span class="ml-2">{{
                            item.name }}</span>
                        </div>
                      </template>
                      <template v-slot:append-item="{ item }">
                        <v-icon> {{ item }} </v-icon>
                      </template>
                    </v-select>


                    <div>Font Size</div>
                    <v-btn-toggle v-model="message.fontSize">
                      <v-btn small><i class="fa-solid fa-font fa-sm"></i> Small</v-btn>
                      <v-btn small><i class="fa-solid fa-font "></i>Normal</v-btn>
                      <v-btn small><i class="fa-solid fa-font fa-lg"></i>Large</v-btn>

                    </v-btn-toggle>

                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel v-if="message.messageType != 'table' || message.messageType != 'table'"
                  class="square-panel">
                  <v-expansion-panel-header class="expansion-panel-title">
                    Legends Options
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-switch label="Show Legends" v-model="message.legend.show"></v-switch>
                    <v-select v-model="message.legend.position" item-text="name" item-value="value"
                      :items="legendPosition"></v-select>

                  </v-expansion-panel-content>
                </v-expansion-panel>

              </v-expansion-panels>
            </v-col>
            <v-col :cols="editMode ? 8 : 12">
              <dashboard-widget :message="message" :key="key"></dashboard-widget>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn elevation="0" @click="close">
                        discard
                    </v-btn>
                    <v-btn color="primary" elevation="0" @click="saveChanges" >
                        Confirm
                    </v-btn>
                </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { log, warn, error } from '@/utils/debugLogger';
import DashboardWidget from './dashboard-widget.vue';
import chartTypes from '../config/chart-types';
export default {
    components:{
        DashboardWidget
    },
data(){
    return {
        chartTypes: chartTypes,
        message:null,
        editMode: false,
        show:false,
        key:0,
        expandedPanels: [0, 1, 2, 3],
        legendOptions: {
        show: true,
        position: 'bottom',
        loading:false,
        oldMessage:{}
      },
      legendPosition: [{ name: 'Top', value: "top" }, { name: 'Left', value: 'left' },
      { name: 'Bottom', value: 'bottom' }, { name: 'Right', value: 'right' }],
    }
},
methods:{
    open(message, { editMode }) {
        this.message = message;
        if(!this.message.legend){
            this.message.legend={
                show:false,
                position:'bottom'
            }
        }
        this.editMode = editMode;
        this.show = true;
    },
    edit() {

        this.editMode = !this.editMode;
    },
    close() {
        this.editMode = false;
        this.show = false;
    },
    saveChanges(){
        this.$emit('updated', this.message);
        this.close();
    }
    
},
watch:{
        message:{
            handler(val,oldVal){
              log(val, oldVal)
              
              if(JSON.stringify( this.message?.legend)!=JSON.stringify( this.oldMessage?.legend)||
                this.message?.fontSize!=this.oldMessage?.fontSize||
                this.message?.messageType!=this.oldMessage?.messageType
              )
            this.key=Date.now();
            this.oldMessage = structuredClone(this.message);
            },
            deep:true
        }
    }
  
}
</script>

<style>

</style>